import React, { useState, useCallback } from 'react';
import Cropper from 'react-easy-crop';
import { createCroppedImageBlob } from '../utils/cropImage';
import './ProfileImageCropModal.css';

export default function ProfileImageCropModal({ imageSrc, open, onSave, onCancel }) {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [saving, setSaving] = useState(false);

  const onCropComplete = useCallback((_croppedArea, pixels) => {
    setCroppedAreaPixels(pixels);
  }, []);

  const handleSave = useCallback(async () => {
    if (!croppedAreaPixels || !imageSrc) return;
    setSaving(true);
    try {
      const blob = await createCroppedImageBlob(imageSrc, croppedAreaPixels, true);
      onSave(blob);
      onCancel();
    } catch (err) {
      console.error('Crop failed:', err);
    } finally {
      setSaving(false);
    }
  }, [imageSrc, croppedAreaPixels, onSave, onCancel]);

  if (!open) return null;

  return (
    <div className="profile-crop-modal-overlay" onClick={onCancel}>
      <div className="profile-crop-modal" onClick={(e) => e.stopPropagation()}>
        <div className="profile-crop-modal-header">
          <h3>Crop profile picture</h3>
          <button type="button" className="profile-crop-modal-close" onClick={onCancel} aria-label="Close">&times;</button>
        </div>
        <div className="profile-crop-modal-cropper-wrap">
          <Cropper
            image={imageSrc}
            crop={crop}
            zoom={zoom}
            aspect={1}
            cropShape="round"
            showGrid={false}
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onCropComplete={onCropComplete}
          />
        </div>
        <div className="profile-crop-modal-zoom">
          <label>Zoom</label>
          <input
            type="range"
            min={1}
            max={3}
            step={0.1}
            value={zoom}
            onChange={(e) => setZoom(Number(e.target.value))}
            className="profile-crop-modal-slider"
          />
        </div>
        <div className="profile-crop-modal-actions">
          <button type="button" className="profile-crop-modal-btn profile-crop-modal-cancel" onClick={onCancel}>
            Cancel
          </button>
          <button
            type="button"
            className="profile-crop-modal-btn profile-crop-modal-save"
            onClick={handleSave}
            disabled={saving || !croppedAreaPixels}
          >
            {saving ? 'Saving…' : 'Save'}
          </button>
        </div>
      </div>
    </div>
  );
}
